<template>
	<button
		@click="toggle"
		type="button"
		class="relative inline-flex h-8 w-14 items-center rounded-full transition-colors focus:outline-none"
		:class="[isActive ? 'bg-blue-500' : 'bg-gray-300']"
		:aria-pressed="isActive">
		<span
			class="flex justify-center items-center h-6 w-6 transform rounded-full bg-white transition-transform"
			:class="[isActive ? 'translate-x-7' : 'translate-x-1']">
			<i v-if="isActive" class="text-base fas text-blue-500" :class="icons[0]"></i>
			<i v-else class="text-base fas text-gray-400" :class="icons[1]"></i>
		</span>
	</button>
</template>

<script setup>
	import { computed } from 'vue';

	const props = defineProps({
		modelValue: {
			type: Boolean,
			default: false,
		},
		icons: {
			type: Array,
			default: ['fa-check', 'fa-xmark'],
		},
	});

	const emit = defineEmits(['update:modelValue']);

	const isActive = computed(() => props.modelValue);

	const toggle = () => {
		emit('update:modelValue', !props.modelValue);
	};
</script>
